import request from '@/utils/request'
import URL from '@/api/urlTranslator'
import { getUserInfo } from '@/utils/auth'
import { getSpecificBasicData, cacheKeys } from '@/utils/basicDataCache'
import { cache } from '@/utils/cacheManager'

export function getCompanyList(data) {
  return request({
    url: URL.partner.companys,
    method: 'post',
    data
  })
}
export function getAdvancedList(data) {
  return request({
    url: URL.partner.advancedQuery,
    method: 'post',
    data
  })
}

export function getCompanyListByType(params) {
  return request({
    url: URL.partner.companyByType,
    method: 'get',
    params
  })
}

/**
 * 为兼容相关调用处的逻辑，此处实现接口：缓存重获取合作伙伴 对应后台 URL.partner.companyByType @see com.walltech.cargo.serivce.impl.CompanyServiceImpl#getListByType
 * @param {Object} params
 * @returns {AxiosPromise}
 */
export async function getCompanyListByType4Cache({ officeId, type, active, likeName }) {
  try {
    let datas = await getSpecificBasicData(cacheKeys.basic_data_Company)
    if (!datas || datas.length === 0) {
      datas = await getSpecificBasicData(cacheKeys.basic_data_Company, true)
    }
    // 进行筛选和过滤 - 和后台 逻辑一致 @see com.walltech.cargo.serivce.impl.CompanyServiceImpl#getListByType
    datas = datas.filter((company, index) => {
      if (type && !company[type]) {
        return false
      }
      if (likeName && !(company.shortName.includes(likeName) || company.cnShortName.includes(likeName) || company.chineseName.includes(likeName) || company.englishName.includes(likeName))) {
        return false
      }
      if (officeId !== void 1) {
        const partnerManagementMode = parseInt(cache.config.get('PartnerManagementMode'))
        if (partnerManagementMode === 1) {
          if (!(company.branchId > 1 && company.branchId === officeId)) {
            return false
          }
        } else {
          if (company.branchId !== 1 && company.branchId !== officeId) {
            return false
          }
        }
      }

      if (active !== void 1 && company.active !== active) {
        return false
      }

      return true
    })
    console.log('getCompanyListByType4Cache =--> datas', datas.length)
    return { ok: true, data: { list: datas }}
  } catch (e) {
    return { ok: false, data: { list: [] }, message: '获取合作伙伴信息失败' }
  }
}

export function getCompanyOne(uuid) {
  return request({
    url: URL.partner.companyOne,
    method: 'get',
    params: { uuid }
  })
}

export function getCompanyByCmpIdx(cmpIdx) {
  const user = getUserInfo()
  return request({
    url: `${URL.partner.companyByCmpIdx}/${user.tenantId}/${cmpIdx}`,
    method: 'get'
  })
}

export function companyCacheByCmpIdx(cmpIdx) {
  return request({
    url: `${URL.partner.companyCacheByCmpIdx}/${cmpIdx}`,
    method: 'get'
  })
}

export function getSettlementAgentsByCompany(companyUuid) {
  return request({
    url: URL.partner.settlementAgentsByCompany,
    method: 'get',
    params: { companyUuid }
  })
}

export function saveSettlementAgentsOfCompany(data) {
  return request({
    url: URL.partner.settlementAgentsOfCompany,
    method: 'post',
    data
  })
}

export function companyFactorySignByCompanyFunc(data) {
  return request({
    url: URL.partner.companyFactorySignByCompanyUrl,
    method: 'post',
    data
  })
}

export function saveCompanyFactorySignOfCompanyFunc(data) {
  return request({
    url: URL.partner.saveCompanyFactorySignOfCompanyUrl,
    method: 'post',
    data
  })
}

export function saveCompany(data) {
  return request({
    url: URL.partner.company,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 保存合作伙伴信息
export function saveCompanyInfo(data) {
  return request({
    url: URL.partner.saveCompanyInfo,
    method: 'post',
    data
  })
}

// 查询合作伙伴-放号信息
export function queryNumberAllocationInfo(data) {
  return request({
    url: URL.partner.queryNumberAllocationInfo,
    method: 'post',
    data
  })
}

// 更新合作伙伴-放号额度
export function saveNumberAllocationLimit(data) {
  return request({
    url: URL.partner.saveNumberAllocationLimit,
    method: 'post',
    data
  })
}

export function validateCompany(data) {
  return request({
    url: URL.partner.validateCompany,
    method: 'post',
    data
  })
}

export function checkOtherCompanySettleAgent(params) {
  return request({
    url: URL.partner.checkOtherCompanySettleAgent,
    method: 'get',
    params
  })
}

export function companyExecBatch(data) {
  return request({
    url: URL.partner.companyExecBatch,
    method: 'post',
    data
  })
}

export function passAuditCompany(params) {
  return request({
    url: URL.partner.companyAuditPass,
    method: 'put',
    params
  })
}

export function rejectAuditCompany(params) {
  return request({
    url: URL.partner.companyAuditReject,
    method: 'put',
    params
  })
}

export function addPartnerAuthorizationByBatch(data) {
  return request({
    url: URL.partner.companyPriceLevel,
    method: 'post',
    data
  })
}

/**
 * 清除合作伙伴关联CRM
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteCompanyCRMFunc(params) {
  return request({
    url: URL.partner.deleteCompanyCRMUrl,
    method: 'get',
    params
  })
}

export function mergeCompanies(params) {
  return request({
    url: URL.partner.companyMerge,
    method: 'post',
    params
  })
}

export function checkQuotationClient(params) {
  return request({
    url: URL.partner.checkQuotationClient,
    method: 'get',
    params
  })
}

export function delCompany(uuid) {
  return request({
    url: URL.partner.companyRest + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function getSettlementAgentsByCmpIdx(cmpIdx) {
  return request({
    url: URL.partner.settlementAgentsByCmpIdx + '?cmpIdx=' + encodeURIComponent(cmpIdx),
    method: 'get'
  })
}

export function getCompanyByCacheId(cmpIdx) {
  return request({
    url: `${URL.partner.getCompanyByCacheId}/${cmpIdx}`,
    method: 'get'
  })
}

export function getWarehouseDetail(companyUuid) {
  return request({
    url: URL.partner.getWarehouseDetail + '?companyUuid=' + encodeURIComponent(companyUuid),
    method: 'get'
  })
}

export function queryCompany(branchId, linkedBranchId) {
  return request({
    url: `${URL.partner.queryCompany}`,
    method: 'get',
    params: { branchId, linkedBranchId }
  })
}

export function mainTainCurrentTenantCompanies(oppositeTenantId, branchId) {
  return request({
    url: `${URL.partner.mainTainCurrentTenantCompanies}/${oppositeTenantId}/${branchId}`,
    method: 'get'
  })
}

export function getCompanyByTenantIdAndBranchIdAndScac(tenantId, branchId, scacCode) {
  return request({
    url: `${URL.partner.getCompanyByTenantIdAndBranchIdAndScac}`,
    method: 'get',
    params: { tenantId, branchId, scacCode }
  })
}

export function getSites(companyUuid) {
  return request({
    url: URL.partner.getSites + '?companyUuid=' + encodeURIComponent(companyUuid),
    method: 'get'
  })
}

export function getSitesFunc(data) {
  return request({
    url: URL.partner.getSitesUrl,
    method: 'post',
    data
  })
}

export function addSites(data) {
  return request({
    url: URL.partner.site,
    method: 'post',
    data
  })
}

// 合作伙伴与其对应用户
export function getCompanyUsers(params) {
  return request({
    url: URL.partner.getCompanyUsers,
    method: 'get',
    params
  })
}

// 查询合作伙伴供应链关系
export function loadPartnerFactoryData(params) {
  return request({
    url: URL.partner.loadPartnerFactoryData,
    method: 'get',
    params
  })
}

// 检验合作伙伴供应链关系
export function checkPartnerFactory(data) {
  return request({
    url: URL.partner.checkPartnerFactory,
    method: 'post',
    data
  })
}

// 新增合作伙伴供应链关系
export function addPartnerFactory(data) {
  return request({
    url: URL.partner.addPartnerFactory,
    method: 'post',
    data
  })
}

// 删除合作伙伴供应链关系
export function deletePartnerFactory(data) {
  return request({
    url: URL.partner.deletePartnerFactory,
    method: 'delete',
    data
  })
}

export function updateSales(data) {
  return request({
    url: URL.partner.updateSales,
    method: 'put',
    data
  })
}

export function checkUsedByAccountingDocument(params) {
  return request({
    url: URL.partner.checkUsedByAccountingDocument,
    method: 'get',
    params
  })
}

export function getAirlineDetail(companyUuid) {
  return request({
    url: URL.partner.getAirlineDetail + '?companyUuid=' + encodeURIComponent(companyUuid),
    method: 'get'
  })
}

// 删除客户前验证【本组客户使用】
export function checkDeleteCustomer(data) {
  return request({
    url: URL.partner.checkDeleteCustomer,
    method: 'post',
    data
  })
}

// 删除客户【本组客户使用】
export function deleteCustomer(data) {
  return request({
    url: URL.partner.deleteCustomer,
    method: 'post',
    data
  })
}

// 查询服务人员对应合作伙伴
export function queryCompanyUserByCompany(params) {
  return request({
    url: URL.partner.queryCompanyUserByCompany,
    method: 'get',
    params
  })
}

// 查询某个岗位的所有合作伙伴
export function queryUserRoleByCompany(params) {
  return request({
    url: URL.partner.queryUserRoleByCompany,
    method: 'get',
    params
  })
}

// 判断销售与客户的关系
export function checkCompany(params) {
  return request({
    url: URL.partner.checkCompany,
    method: 'get',
    params
  })
}
// 沃联查询租户列表
export function wTQueryPageHandler(data) {
  return request({
    url: URL.wt.wtQueryCompanyLitUrl,
    method: 'post',
    data
  })
}
// 沃联发送审核信息
export function wTSendHandler(data) {
  return request({
    url: URL.wt.wtSendExamineUrl,
    method: 'post',
    data
  })
}
// 沃联审核列表
export function wtQueryApplyLitFunc(data) {
  return request({
    url: URL.wt.wtQueryApplyLit,
    method: 'post',
    data
  })
}

// 沃联审核列表
export function deleteApplyFunc(data) {
  return request({
    url: URL.wt.wtDeleteApplyUrl,
    method: 'post',
    data
  })
}

// 加载合作伙伴关联信息
export function loadCompanyRelated(data) {
  return request({
    url: URL.partner.loadCompanyRelated,
    method: 'post',
    data: data
  })
}
// 根据中英文名称加载合作伙伴
export function getCompanyByName(name) {
  return request({
    url: URL.partner.getCompanyByName,
    method: 'get',
    params: { name }
  })
}

// 更新客商数据
export function downLoadPartners(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.partner.downLoadPartners,
    method: 'post',
    data
  })
}

// 根据合作伙伴的中文名称校验是否在其他分公司存在，如果存在则返回所在分公司名称
export function validateCompanyByChineseNameFunc(params) {
  return request({
    url: URL.partner.validateCompanyByChineseNameUrl,
    method: 'get',
    params
  })
}

export function queryCompanyList(data) {
  return request({
    url: URL.partner.queryCompanyList,
    method: 'post',
    data
  })
}

export function getSettlementAgentsByCmpIdxList(data) {
  return request({
    url: URL.partner.getSettlementAgentsByCmpIdxList,
    method: 'post',
    data
  })
}

export function getCustomerVendorRatingFunc(data) {
  return request({
    url: URL.partner.getCustomerVendorRatingUrl,
    method: 'post',
    data
  })
}

export function getBackUpWarehouseCompany() {
  return request({
    url: URL.partner.getBackUpWarehouseCompany,
    method: 'get'
  })
}

// 批量维护信控
export function batchSaveCreditInfos(data) {
  return request({
    url: URL.partner.batchSaveCreditInfos,
    method: 'post',
    data
  })
}

// 批量维护黑名单
export function batchSaveBlacklist(data) {
  return request({
    url: URL.partner.batchSaveBlacklist,
    method: 'post',
    data
  })
}

// 批量查询公司在当前是否有有效的客户合同
export function batchQueryCustomerCompanyIsOver(data) {
  return request({
    url: URL.partner.batchQueryCustomerCompanyIsOver,
    method: 'post',
    data
  })
}

export function updateLinkedBranchIdByOffice(params) {
  return request({
    url: URL.partner.updateLinkedBranchIdByOfficeUrl,
    method: 'get',
    params
  })
}

export function exportAgent(params) {
  return request({
    url: URL.partner.exportAgent,
    method: 'get',
    params
  })
}

// 中文名称是否已存在
export function chineseNameIsExist(params) {
  return request({
    url: URL.partner.chineseNameIsExist,
    method: 'get',
    params
  })
}

// 获取相似合作伙伴列表
export function getSimilarPartners(data) {
  return request({
    url: URL.partner.getSimilarPartners,
    method: 'post',
    data
  })
}

export function hasPartnerPrivilegeBranches() {
  return request({
    url: URL.partner.hasPartnerPrivilegeBranches,
    method: 'get'
  })
}

// 查询服务人员关联的客户
export function queryCompanyCmpIdxByCompanyUser(params) {
  return request({
    url: URL.partner.queryCompanyCmpIdxByCompanyUser,
    method: 'get',
    params
  })
}

export function getCNptFunc(cmpIdx) {
  return request({
    url: URL.partner.getCNptUrl + '?cmpIdx=' + cmpIdx,
    method: 'get'
  })
}

export function addCNpt(data) {
  return request({
    url: URL.partner.addCNptUrl,
    method: 'post',
    data
  })
}

// 校验预付款客户
export function validateCustomerCode(data) {
  return request({
    url: URL.partner.validateCustomerCodeUrl,
    method: 'post',
    data
  })
}

// 放号配置-统一校验委托单位
export function validateReleaseNumberCustomer(data) {
  return request({
    url: URL.partner.validateReleaseNumberCustomerUrl,
    method: 'post',
    data
  })
}

export function cancelAuditCompany(data) {
  return request({
    url: URL.partner.companyCancelAudit,
    method: 'put',
    data
  })
}

// 名称前缀匹配
export function namePrefixMatch(data) {
  return request({
    url: URL.partner.namePrefixMatch,
    method: 'post',
    data
  })
}

// 航空公司匹配
export function airlineCompanyMatch(data) {
  return request({
    url: URL.partner.airlineCompanyMatch,
    method: 'post',
    data
  })
}

export function getcmpIdxByShipCompanyCode(data) {
  return request({
    url: URL.partner.getcmpIdxByShipCompanyCode + '?shipCompanyCode=' + data,
    method: 'get'
  })
}

export function isExistUserIdByCompany(data) {
  return request({
    url: URL.partner.isExistUserIdByCompany,
    method: 'post',
    data
  })
}

export function getCmpIdxByLocal(data) {
  return request({
    url: URL.partner.getCmpIdxByLocal,
    method: 'post',
    data
  })
}

export function addCompanyApplicationFunc(data) {
  return request({
    url: URL.partner.addCompanyApplicationUrl,
    method: 'post',
    data
  })
}

export function checkCompanyExistFunc(params) {
  return request({
    url: URL.partner.checkCompanyExistUrl,
    method: 'get',
    params: params
  })
}

export function applyReleaseApplication(data) {
  return request({
    url: URL.partner.applyReleaseApplication,
    method: 'post',
    data
  })
}

